import React, {Component} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import {computeSliderArrows, computeSliderCount, computeTotalSlides} from "./utils";
import availableLabel from './assets/images/Available.png';
import comingSoonLabel from './assets/images/Coming_Soon.png';
import maleLabel from './assets/images/male.png';
import femaleLabel from './assets/images/female.png';

class PetCarousel extends Component {
    render() {
        let listPresent = this.props.adopts && this.props.adopts.length > 0;
        if (listPresent) {
            return <PetsList
                adopts={this.props.adopts}
                onClick={(i) => this.props.onClick(i)}
                adoptType={this.props.adoptType}
                selectedIndex={this.props.selectedIndex}
            />;
        } else {
            return <EmptyList/>;
        }
    }
}

class PetsList extends Component {
    constructor(props) {
        super(props);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.setTotalSlides = this.setTotalSlides.bind(this);
        this.setSliderCount = this.setSliderCount.bind(this);
        this.setShowArrows = this.setShowArrows.bind(this);
        this.state = {
            totalSlidesCount: this.computeTotalSlidesCount(),
            totalSlides: computeTotalSlides(this.props.adopts.length, 3),
            sliderCount: computeSliderCount(3),
            showArrows: computeSliderArrows(this.props.adopts.length, 3),
            selectedItem: 0
        };
    }

    componentWillUnmount() {
        window.clearTimeout(this.throttle);
        window.removeEventListener('resize', this.handleWindowResize, false);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize, false);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.handleWindowResize();
    }

    handleWindowResize() {
        window.clearTimeout(this.throttle);
        this.throttle = window.setTimeout(this.setTotalSlides, 200);
        this.throttle = window.setTimeout(this.setSliderCount, 200);
        this.throttle = window.setTimeout(this.setShowArrows, 200);
    }

    computeTotalSlidesCount() {
        return this.props.adopts.length;
    }

    setTotalSlides() {
        let totalSlides;
        if (parseInt(this.props.selectedIndex) === 0) {
            totalSlides = computeTotalSlides(this.props.adopts.length, 3);
        } else if (parseInt(this.props.selectedIndex) === 1) {
            totalSlides = computeTotalSlides(this.props.adopts.length, 2);
        } else if (parseInt(this.props.selectedIndex) === 2) {
            totalSlides = computeTotalSlides(this.props.adopts.length, 1);
        }

        if (this.state.totalSlides !== totalSlides) {
            this.setState({
                totalSlides: totalSlides
            });
        }
    }

    setSliderCount() {
        let sliderCount;
        if (parseInt(this.props.selectedIndex) === 0) {
            sliderCount = computeSliderCount(3);
        } else if (parseInt(this.props.selectedIndex) === 1) {
            sliderCount = computeSliderCount(2);
        } else if (parseInt(this.props.selectedIndex) === 2) {
            sliderCount = computeSliderCount(1);
        }
        if (this.state.sliderCount !== sliderCount) {
            this.setState({
                sliderCount: sliderCount
            });
        }
    }

    setShowArrows() {
        let showArrows;
        if (parseInt(this.props.selectedIndex) === 0) {
            showArrows = computeSliderArrows(this.props.adopts.length, 3);
        } else if (parseInt(this.props.selectedIndex) === 1) {
            showArrows = computeSliderArrows(this.props.adopts.length, 2);
        } else if (parseInt(this.props.selectedIndex) === 2) {
            showArrows = computeSliderArrows(this.props.adopts.length, 1);
        }
        if (this.state.showArrows !== showArrows) {
            this.setState({
                showArrows: showArrows
            });
        }
    }

    handleClick = (event, index) => {
        this.props.onClick(index)
    }

    handleSelectedItem = (e) => {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (width < 992) {
            this.setState({selectedItem: e});
        } else if (e + 2 >= this.props.adopts.length) {
            this.setState({selectedItem: this.props.adopts.length - 1});
        } else if (e < 2) {
            this.setState({selectedItem: 0});
        } else {
            this.setState({selectedItem: e});
        }
    }

    slidesCount() {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (width < 992) {
            return 1;
        } else if (this.state.selectedItem === 0 || (this.state.selectedItem === this.props.adopts.length - 1)) {
            return this.state.sliderCount + 1
        } else {
            return this.state.sliderCount;
        }
    }

    showListItem = (pet, index) => {
        if (parseInt(this.props.selectedIndex) === 0) {
            return (
                this.adoptionListItem(pet, index)
            )
        } else if (parseInt(this.props.selectedIndex) === 1) {
            return (
                this.foundationListItem(pet, index)
            )
        } else if (parseInt(this.props.selectedIndex) === 2) {
            return (
                this.pairingListItem(pet, index)
            )
        }
    }

    adoptionListItem(pet, index) {
        return (
            <div
                className={`adoption-pet-list__item  messaging-list__item animals-for-sale`}
                key={index}
                data-key={index}
                onClick={i => this.handleClick(i, index)}
            >
                <div className="messaging-list__item__block pairing-layout">
                    <span>
                        <img
                            src={pet.images && pet.images.length > 0 ? pet.images[0].url : ''}
                            alt={pet.name}/>
                    </span>
                    <span className='carousel-gender-label'>
                        <img className='carousel-gender-label-image'
                             src={this.returnGenderLabel(pet)} alt={pet.adoption_status}/>
                    </span>
                </div>

                <div className="messaging-list__item__desc">
                    <div className="messaging-list__item__top adoption-pet-list__item__top">
                        <ul>
                            <li><h3 className="messaging-list__item__title">{pet.name}</h3>
                            </li>
                            <li><h4>{pet.breed}</h4></li>

                        </ul>
                        <span className='carousel-available-image'>
                                <img className='carousel-available-image'
                                     src={this.returnAdoptionLabel(pet)} alt={pet.adoption_status}/>
                            </span>
                    </div>
                </div>
            </div>
        )
    }

    foundationListItem(pet, index) {
        return (
            <div
                className={`adoption-pet-list__item  messaging-list__item animals-of-foundation`}
                key={index}
                data-key={index}
                onClick={i => this.handleClick(i, index)}
            >
                <div className="messaging-list__item__block pairing-layout">
                        <span>
                            <img
                                src={pet.images && pet.images.length > 0 ? pet.images[0].url : ''}
                                alt={pet.name}/>
                        </span>
                </div>

                <div className="messaging-list__item__desc">
                    <div className="messaging-list__item__top adoption-pet-list__item__top">
                        <ul>
                            <li><h3 className="messaging-list__item__title">{pet.name}</h3>
                            </li>
                            <li><h4>{this.genderAndBreed(pet)}</h4></li>

                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    pairingListItem(pet, index) {
        return (
            <div
                className={`adoption-pet-list__item  messaging-list__item animals-in-pairing`}
                key={index}
                data-key={index}
                onClick={i => this.handleClick(i, index)}
            >
                <div>
                    <div className="messaging-list__item__block pairing-layout">
                        <span>
                            <img src={pet.sire.image} alt={pet.sire.name}/>
                        </span>
                    </div>

                    <div className="messaging-list__item__desc">
                        <div className="messaging-list__item__top adoption-pet-list__item__top">
                            <ul>
                                <li><h3 className="messaging-list__item__title">{pet.sire.name}</h3>
                                </li>
                                <li><h4>{this.genderAndBreed(pet.sire)}</h4></li>

                            </ul>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="messaging-list__item__block pairing-layout">
                        <span>
                            <img src={pet.dam.image} alt={pet.dam.name}/>
                        </span>
                    </div>

                    <div className="messaging-list__item__desc">
                        <div className="messaging-list__item__top adoption-pet-list__item__top">
                            <ul>
                                <li><h3 className="messaging-list__item__title">{pet.dam.name}</h3>
                                </li>
                                <li><h4>{this.genderAndBreed(pet.dam)}</h4></li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    returnAdoptionLabel(pet) {
        if (pet.label === 'coming_soon') {
            return comingSoonLabel;
        } else if (pet.label === 'available') {
            return availableLabel;
        } else if (pet.label === 'adopted') {
            return availableLabel;
        } else {
            return ''
        }
    }

    returnGenderLabel(pet) {
        if (pet.gender === 'Female') {
            return femaleLabel;
        } else {
            return maleLabel;
        }
    }

    genderAndBreed = (pet) => {
        if (pet.gender === 'Female') {
            return (
                'Dam' + ' | ' + pet.breed
            )
        } else {
            return (
                'Sire' + ' | ' + pet.breed
            )
        }
    }

    render() {
        return (
            <>
                <Carousel
                    showThumbs={false}
                    onClickItem={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={false}
                    centerMode={true}
                    selectedItem={this.state.selectedItem}
                    onChange={(e) => {
                        this.handleSelectedItem(e)
                    }}
                    showArrows={this.state.showArrows}
                    slidesCount={this.slidesCount()}
                    centerSlidePercentage={100 / this.state.totalSlides}
                >
                    {this.props.adopts.map((pet, index) => (
                        this.showListItem(pet, index)
                    ))}
                </Carousel>
            </>
        );
    }
}

function EmptyList(props) {
    return <h1></h1>;
}

export default PetCarousel;
        